export type GetComponentProjectRequest = {
  pjtId: string;
};
